import { createContext, useContext, useMemo } from 'react';
import { useSearchFilters } from '../../common/components/SearchHeader/filters/useSearchFilters';
import { ChildrenOnly } from '../../common/types/ChildrenOnly';
import { renderSeoContent } from './renderers';
import { SeoContent } from './types';

export const SeoContext = createContext<null | SeoContent>(null);

export const SeoContentProvider = ({ children }: ChildrenOnly) => {
  const [filters] = useSearchFilters();

  const content = useMemo((): SeoContent => renderSeoContent(filters), [filters]);

  return <SeoContext.Provider value={content}>{children}</SeoContext.Provider>;
};

export const useSeoContent = () => useContext(SeoContext);
